import * as React from 'react';
import { Route, Redirect } from "react-router";
import { useAuth } from "../modules/auth/shared/hooks/useAuth";
import { useHookSubscribe } from '../modules/react-rxjs';
import { userService } from '../modules/user';
import { browserHistory } from './history';

export interface ProtectedMigrationRouteProps {
  path: string;
  component: React.ComponentType<any>;
  exact?: boolean;
}

export const ProtectedMigrationRoute: React.FC<ProtectedMigrationRouteProps> = props => {
  const user = useHookSubscribe(null, userService.user$);
  const { exact, path, component } = props;
  const [pathname, setPathName] = React.useState(window.location.pathname);
  React.useEffect(() => {
    if (user?.migrationPasswordValid === false && pathname !== '/user') {
      browserHistory.push('/user');
    }
  }, [pathname, user]);

  React.useEffect(() => {
    const uncb = browserHistory.listen(location => {
      setPathName(location.pathname);
    });
    return () => {
      uncb();
    }
  }, []); 
  return <Route exact={exact} path={path} component={component} />;
}